<template>
    <Breadcrumb>
        <BreadcrumbItem
            v-for="item in currentPath"
            :to="item.path"
            :key="item.name"
        >{{ itemTitle(item) }}</BreadcrumbItem>
    </Breadcrumb>
</template>

<script>
export default {
  name: 'breadcrumbNav',
  props: {
    currentPath: Array
  },
  methods: {
    itemTitle (item) {
      if (typeof item.title === 'object') {
        return this.$t(item.title.i18n)
      } else {
        return item.title
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/main-components/breadcrumb-nav.vue